export default __webpack_public_path__ + "static/media/mb_logo.dfddaed5.png";